import React from "react";
import Items from "../../Components/pages/items/items";

function Index() {
  return <Items />;
}

export default Index;
